module.exports = __webpack_public_path__ + "static/img/image14.30b146e4.png";